<template>
  <div class="acts-mode-control">
    <i-button :icon="getIcon()" @click="toggleMode">
      {{ getLabel() }}
    </i-button>
  </div>
</template>

<script>
export default {
  computed: {
    actsMode () {
      return this.$store.state.filters.actsMode
    }
  },
  methods: {
    toggleMode () {
      const value = this.actsMode === 'list' ? 'group' : 'list'
      this.$store.commit('SET_VIEW_MODE', { name: 'actsMode', value })
    },
    getIcon () {
      return this.actsMode === 'list' ? 'md-list' : 'ios-apps'
    },
    getLabel () {
      return this.actsMode === 'list' ? 'Список' : 'Группы'
    }
  }
}
</script>

<style>

</style>
